/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRecommendationByAccountRequest {
    getFixupPrototypeFunction() { return ListRecommendationByAccountRequest.fixupPrototype; }

    static newInstance(model: Partial<ListRecommendationByAccountRequest>): ListRecommendationByAccountRequest {
        let obj = Object.assign(new ListRecommendationByAccountRequest(), model);
        ListRecommendationByAccountRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRecommendationByAccountRequest>): ListRecommendationByAccountRequest {
        if (!model) return null;
        return ListRecommendationByAccountRequest.newInstance(<ListRecommendationByAccountRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRecommendationByAccountRequest) {
        if (!obj) return;

        models.ListRecommendationByAccountRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRecommendationByAccountRequest): boolean {
        Object.setPrototypeOf(obj, ListRecommendationByAccountRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    service_account_id: string;

    policy_id: string;

}
